// src/components/ThreeDAnimation.js
import React from 'react';
import '../styles/App.css'; // Import the consolidated App.css
import logo from '../WizeAssist_white_logo.png'; // Updated path

function ThreeDAnimation() {
  return (
    <div className="animation-container">
      {/* Background Logo */}
      <div className="animation-background">
        <img src={logo} alt="WizeAssist Logo" className="background-logo" />
      </div>

      {/* Video Removed */}
      {/* 
      <video
        className="animation-video"
        src={animationVideo}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        aria-label="WizeAssist Animated Logo"
      >
        Your browser does not support the video tag.
      </video> 
      */}
    </div>
  );
}

export default ThreeDAnimation;
